import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import Button from 'components/Button'

export const ComanyDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const CommonFlex = styled(Flex)`
  margin-top: 25px;
  width: 100%;
`
export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #4d566e;
  width: 35%;
`
export const CityName = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: #999fac;
`
export const DefaultDiv = styled.div`
  padding: 4px 6px;
  width: 56px;
  height: 23px;
  background: #fef8f3;
  border-radius: 6px;
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: #f3a66e;
`
export const HeadFlex = styled(Flex)`
  gap: 5px;
`
export const DefaultFlex = styled(Flex)`
  gap: 8px;
`
export const AddLocationButton = styled(Button.Secondary)`
  border: none !important;
  background: none !important;
  box-shadow: none !important;
`
export const NoDataDiv = styled.div`
  margin: 50px 0;
`
export const IconDiv = styled.div`
  cursor: pointer;
`
export const ScrollWrapper = styled.div`
  width: 55%;
  .ant-list-split .ant-list-item {
    border-bottom: none;
  }
  .ant-list-item {
    padding: 0;
  }
  .infinite-scroll-component {
    ::-webkit-scrollbar {
      display: '';
    }
  }
`
